module.exports = __webpack_public_path__ + "img/18.c507a694.jpg";